import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import SideMenu from "../../../components/menus/m-side";
import { useNavHeight } from "../../../__utils/context/navheightprovider";
import PdfViewer from "../../../__utils/tools/pdf-viewer";
import pdfReglementInterieur from "../../../assets/img/tcfReglementInterieur20241108.pdf";

const ReglementInterieur = () => {
  const { navbarHeight } = useNavHeight();

  return (
    <main role="main" className="mc-fond-courts-couverts">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            xs={12}
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
            }}
          >
            <SideMenu />
          </Col>
          <Col xs={12} md={9} className="m-auto">
            <h1 className="m-3 mc-rampart mc-rfs-2 text-center mc-title">
              Règlement Intérieur
            </h1>
            <Card className="bg-transparent justify-content-between mx-2 mt-3 border-0">
              <Card.Body className="m-2 rounded-3 border border-5 border-warning text-center text-light">
                <PdfViewer
                  pdfFile={pdfReglementInterieur}
                  pageNo={1}
                  toolTipText={"Télécharger le règlement intérieur"}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default ReglementInterieur;
